// extracted by mini-css-extract-plugin
export default {"container":"TemperatureCircle_container__t3XfU","svg":"TemperatureCircle_svg__7snEZ","temperature":"TemperatureCircle_temperature__kolLS"};